import { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import { IQuestionV2 } from '../../store/reports/types'

import {
  updateNewCaseAnswerText,
  updateVictimAnswerText,
} from '../../store/questions/questionsSlice'
import DateRangePicker from '../../components/DateRangePicker'

interface IDateQuestion {
  question: IQuestionV2
  victimQuestionId?: number | null
}

const DateQuestion: FC<IDateQuestion> = ({ question, victimQuestionId = null }) => {
  const dispatch = useDispatch<AppDispatch>()

  const getAnswer = () => {
    if (victimQuestionId) {
      return useSelector(questionsSelector.getVictimAnswer(victimQuestionId, question?.uuid))
    }
    return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  }

  const answer = getAnswer()

  const onChange = (dates: Date) => {
    if (victimQuestionId) {
      dispatch(
        updateVictimAnswerText({
          victimId: victimQuestionId,
          answerUUID: answer?.uuid,
          answerText: dates?.toDateString(),
        }),
      )
      return
    }
    dispatch(
      updateNewCaseAnswerText({
        answerUUID: answer?.uuid,
        answerText: dates?.toDateString(),
      }),
    )
  }

  return <DateRangePicker label={question?.variant?.label} setDate={onChange} />
}

export default DateQuestion
